import { faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  StyledActions,
  StyledCta
} from 'components/marketingSite/shared/Cta.styled';
import ButtonLink from 'components/shared/ButtonLink.styled';
import { Heading3 } from 'components/shared/Typography';
import { LoggedUserContext } from 'context/logged-user/loggeduser.context';
import { useI18n } from 'hooks/useI18n';
import { useMediaQuery } from 'hooks/useMediaQuery';
import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import { useContext } from 'react';
import ServiceEventTracking from 'services/service.event-tracking';
import styled, { css } from 'styled-components';
import { color, container, screen, spacing } from 'theme';
import { APP_URLS, getAppUrl } from 'utils/app-urls';

const StyledCtaBorder = styled(StyledCta)<{ $alt: boolean }>`
  background-color: #dcb4e8;
  color: #52105e;

  margin: ${spacing('xs')};
  margin-top: ${spacing('xl4')};
  margin-bottom: ${spacing('xl4')};
  padding-top: ${spacing('xl4')};
  padding-bottom: ${spacing('xl4')};
  padding-left: ${spacing('xl5')};
  padding-right: ${spacing('xl5')};

  width: 95%;
  height: 100%;
  object-fit: cover;
  text-align: left;

  mask-image: url('/images/common/irregular-box-white.svg');
  mask-size: 100% 100%;
  mask-repeat: no-repeat;
  mask-position: center;

  -webkit-mask-image: url('/images/common/irregular-box-white.svg');
  -webkit-mask-size: 100% 100%;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;

  @media (max-width: ${screen('md')}) {
    padding: ${spacing('xl')};

    ${({ $alt }) =>
      !$alt &&
      css`
        background-color: white;
        color: ${color('midnight_700')};
      `}
  }
`;

const StyledButtonLink = styled(ButtonLink)`
  width: max-content;
  white-space: nowrap;
  flex: 0 0 auto;
  margin-top: 0;
  display: inline-flex;
`;

const StyledActionsBorder = styled(StyledActions)`
  justify-content: left;
  max-width: ${container('xs')};
  margin-top: ${spacing('md')};
`;

const Cta = ({ alt = false }: { alt?: boolean }): JSX.Element | null => {
  const { t } = useI18n('success-stories');
  const { locale } = useRouter();
  const { user, loadingUser } = useContext(LoggedUserContext);
  const isMobile = useMediaQuery(`(max-width: 672px)`);

  const commonButtonProps = {
    variant: 'blogCompany',
    sizes: 'md',
    onClick: (e: React.MouseEvent<HTMLAnchorElement>) =>
      ServiceEventTracking.trackExternalLandingCtaClicked(
        e,
        `${getAppUrl(APP_URLS.hrAsAService)}`,
        'footer-success-stories'
      )
  };

  if (user || loadingUser) {
    return null;
  }

  return (
    <StyledCtaBorder $alt={alt}>
      <Heading3>{t('cta.title')}</Heading3>
      <div
        dangerouslySetInnerHTML={{
          __html: t('cta.desc')
        }}
      ></div>
      <StyledActionsBorder>
        <Link href={`${getAppUrl(APP_URLS.hrAsAService)}`} passHref>
          {isMobile ? (
            <StyledButtonLink {...commonButtonProps}>
              <span>{t('cta.action-small')}</span>
            </StyledButtonLink>
          ) : (
            <StyledButtonLink {...commonButtonProps}>
              <span>{t('cta.action')}</span>
              <FontAwesomeIcon icon={faArrowRight} />
            </StyledButtonLink>
          )}
        </Link>
      </StyledActionsBorder>
    </StyledCtaBorder>
  );
};

export default Cta;
